<template>
  <b-dropdown class="ld-multi-select"
    v-model="internalValue" 
    v-bind="$attrs"
    aria-role="list">
    <template #trigger>
      <b-button 
        icon-right="menu-down" 
        :label="displayLabel" 
        type="is-light" />
    </template>
    <b-dropdown-item 
      v-for="option in data" 
      has-link
      :key="getOptionKey(option)"
      :value="option"
      :class="{ 'is-selected': isSelected(option) }"
      aria-role="listitem">
      {{ getOptionLabel(option) }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "LdSelect",
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Select options'
    },
    optionKey: {
      type: String,
      default: 'id'
    },
    optionLabel: {
      type: String,
      default: 'name'
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    displayLabel() {
      const isMultiple = this.$attrs.multiple !== false
      
      if (!isMultiple) {
        return this.internalValue ? this.getOptionLabel(this.internalValue) : this.placeholder
      }
      
      if (this.internalValue.length === 0) {
        return this.placeholder
      } else if (this.internalValue.length === 1) {
        return this.getOptionLabel(this.internalValue[0])
      } else {
        return this.internalValue.map(option => this.getOptionLabel(option)).join('\n')
      }
    }
  },
  methods: {
    getOptionKey(option) {
      return typeof option === 'object' ? option[this.optionKey] : option
    },
    getOptionLabel(option) {
      return typeof option === 'object' ? option[this.optionLabel] : option
    },
    isSelected(option) {
      return this.internalValue.includes(option)
    }
  }
}
</script>

<style scoped lang="scss">
.ld-multi-select {
  :deep(.dropdown-content) {
    max-height: 300px;
    overflow-y: auto;
    background: var(--ld-bg-primary) !important;
  }
  :deep(.has-link) {
    padding: 6px 10px 8px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.05s linear;
    &:hover {
      background: var(--ld-bg-primary);
    }
    &:not(:last-child) {
      border-bottom: 1px solid var(--ld-border-default);
    }
    &.is-selected {
      background-color: var(--ld-brand-primary);
      color: var(--ld-text-inverse);
      &:hover {
        background: var(--ld-brand-primary);
        filter: brightness(0.9);
      }
    }
  }
}
.ld-multi-select button {
  background-color: var(--ld-bg-primary) !important;
  color: var(--var-text-primary);
  font-size: 15px !important;
  width: 100% !important;
  justify-content: space-between;
  padding-bottom: calc(0.5em - 1px) !important;
  padding-left: calc(0.75em - 1px) !important;
  padding-right: calc(0.75em - 1px) !important;
  padding-top: calc(0.5em - 1px) !important;
  :deep(span) {
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style> 